import { render, staticRenderFns } from "./StatisticsDevice.vue?vue&type=template&id=031f41e8&scoped=true&"
import script from "./StatisticsDevice.vue?vue&type=script&lang=js&"
export * from "./StatisticsDevice.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsDevice.vue?vue&type=style&index=0&id=031f41e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f41e8",
  null
  
)

export default component.exports